import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useEffect, useState } from "react";
import "./App.css";
import {
  About,
  Contact,
  CreateAccount,
  Download,
  EpisodePage,
  Home,
  MoviesPage,
  MovieDetailsPage,
  Search,
  SignIn,
  TvShows,
  TvShowsDetailsPage,
  Genres,
  GenreDetails,
  Anime,
  AnimeDetailsPage,
} from "./pages";
import ScrollToTop from "./components/ScrollToTop";
import Sidebar from "./components/Sidebar";
import { SidebarProvider, useSidebar } from "./contexts/SidebarContext";

const AppContent = () => {
  const { isCollapsed } = useSidebar();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 1000);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  
  return (
    <>
      <ScrollToTop />
      <Sidebar />
      <div className={`main-content ${isCollapsed && !isMobile ? 'sidebar-collapsed' : ''}`}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/movies" element={<MoviesPage />} />
          <Route path="/movies/:id" element={<MovieDetailsPage />} />
          <Route path="/genres" element={<Genres />} />
          <Route path="/genres/:type/:id/:name" element={<GenreDetails />} />
          <Route path="/tvshows" element={<TvShows />} />
          <Route path="/tvshows/:id" element={<TvShowsDetailsPage />} />
          <Route path="/anime" element={<Anime />} />
          <Route path="/anime/:id" element={<AnimeDetailsPage />} />
          <Route
            path="/tvshows/:id/:season_number/:episode_number"
            element={<EpisodePage />}
          />
          <Route path="/about" element={<About />} />
          <Route path="/download" element={<Download />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/create-account" element={<CreateAccount />} />
          <Route path="/search/:searchTerm" element={<Search />} />
          <Route path="/sign-in" element={<SignIn />} />
        </Routes>
      </div>
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <SidebarProvider>
        <AppContent />
      </SidebarProvider>
    </BrowserRouter>
  );
}

export default App;
